import api from '@app/utils/api';

export const login = (body) => {
  return api.post('/login', body);
};

export const loadUser = ({token}) => {
  return api.get('/me', {
    notIncludeToken: true,
    headers: {Authorization: `Bearer ${token}`},
  });
};
